import React, { useState, useContext, useEffect } from 'react';
import { IonContent, IonFab, IonFabList, IonFabButton } from '@ionic/react';
import { SideSheet, Pane, Heading, Table, SelectField, EditIcon, UndoIcon, Button, Paragraph, Position, Textarea, TrashIcon, AddIcon, Icon, ChatIcon, TextInputField, MoreIcon, IconButton, ResetIcon, EyeOpenIcon, TextareaField, Spinner, Checkbox } from 'evergreen-ui';
import moment from 'moment';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { globalContext } from "../global/Store";
import { CreateCaseQueryResponse } from "../global/Types";
import { dataRepoContext } from "../data-repo/DataRepo";

export const MyQueries = (props: any) => {


  const { globalDataRepo } = useContext(dataRepoContext);

  const { globalState, dispatch, globalFunctions } = useContext(globalContext);
  const [unfilteredItems, setUnfilteredItems] = useState([]);
  const [items, setItems] = useState([]);
  const [showAddForm, setShowAddForm] = useState(false);
  const [formTitle, setFormTitle] = useState('Add');
  const [newQueryResponse, setNewQueryResponse] = useState({ message: '' });
  const [selectedCaseQuery, setSelectedCaseQuery] = useState({ caseId: 0, isClosed: 0, id: 0, responses: [] });
  const [selectedCaseQueryResponses, setSelectedCaseQueryResponses] = useState([]);
  const [querySubject, setQuerySubject] = useState("");
  const [queryText, setQueryText] = useState("");
  const [querySubjectInvalid, setquerySubjectInvalid] = useState(false);
  const [selectedCase, setSelectedCase] = useState({ caseStatus: { description: '' } });

  const [queryTextInvalid, setqueryTextInvalid] = useState(false);
  const [showNewReponseForm, setShowNewReponseForm] = useState(false);
  const [currentStatus, setCurrentStatus] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  const [newQueryDisabled, setNewQueryDisabled] = useState(false);
  const [showNewQueryFormLoading, setShowNewQueryFormLoading] = useState(false);
  const [showFormLoading, setShowFormLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState('All');

  useEffect(() => {
    globalDataRepo.GetMyCaseQueryList().then(
      function (response: any) {
        setItems(response);
        setUnfilteredItems(response);
        setStatusFilter('All');
      },
      function (error: any) {
        console.error(error);

        globalFunctions.HandleToast({
          header: "Error",
          id: "Case-Read-Error",
          description: "Could not load case query  details",
          type: "danger",
          error: error
        });
      }
    );
  }, []);

  const closeComplete = () => {
    props.onMyQueriesComplete();
  }

  const handleCancel = () => {
    setShowAddForm(false);
    setquerySubjectInvalid(false);
    setqueryTextInvalid(false);
  }

  const isFormValid = () => {

    var _querySubjectInvalid = (querySubject === '' ? true : false);
    var _queryTextInvalid = (queryText === '' ? true : false);

    setquerySubjectInvalid(_querySubjectInvalid);
    setqueryTextInvalid(_queryTextInvalid);

    if (_querySubjectInvalid || _queryTextInvalid) {
      return false;
    }

    return true;
  }

  const updateStatus = () => {

    if (isClosed) {

      setShowFormLoading(true);

      globalDataRepo.CloseCaseQuery(selectedCaseQuery.id).then(
        function (response: any) {
          //setCaseDetails(response);


          globalDataRepo.GetMyCaseQueryList().then(
            function (response: any) {
              setItems(response);
              setUnfilteredItems(response)
              setStatusFilter('All');
              setShowFormLoading(false);
              handleCancel();
            },
            function (error: any) {
              console.error(error);
              setShowFormLoading(false);
              handleCancel();
              globalFunctions.HandleToast({
                header: "Error",
                id: "Case-Read-Error",
                description: "Could not read case details from database",
                type: "danger",
                error: error
              });
            }
          );
        },
        function (error: any) {
          console.error(error);
          setShowFormLoading(false);
          handleCancel();
          globalFunctions.HandleToast({
            header: "Error",
            id: "Case-Query-Close-Error",
            description: "Could not close case query in database",
            type: "danger",
            error: error
          });
        }
      );
    } else {

      handleCancel();
    }
  }

  const viewReply = (_selected: any) => {
    setNewQueryResponse(_selected,);
    setShowNewReponseForm(true);
    setFormTitle('Edit');
    setNewQueryDisabled(true);

  }

  const handleAddResponse = () => {

    setShowFormLoading(true);
    let dateTime = new Date();
    var momentDate = moment(dateTime);

    let queryResponseToAdd: CreateCaseQueryResponse = {
      ResponseDate: momentDate.format(),
      Message: newQueryResponse.message,
      CaseQueryId: selectedCaseQuery.id,
      ResponseUserId: !!globalState.user.userId ? globalState.user.userId : 0,
      CaseId: selectedCaseQuery.caseId
    }

    globalDataRepo.CreateCaseQueryResponse(queryResponseToAdd).then(
      function (response: any) {

        setShowNewReponseForm(false);

        globalDataRepo.GetCaseQueryResponseList(selectedCaseQuery.id, false).then(
          function (response: any) {

            // var _ammendedCaseQuery = selectedCaseQuery;
            // _ammendedCaseQuery.responses = response;
            setSelectedCaseQuery({ ...selectedCaseQuery, ...selectedCaseQuery.responses = response });
            setSelectedCaseQueryResponses(response);
            setShowFormLoading(false);

          },
          function (error: any) {
            console.error(error);
            setShowFormLoading(false);
            globalFunctions.HandleToast({
              header: "Error",
              id: "Case-Query-Response-List-Error",
              description: "Could not read query response list from database",
              type: "danger",
              error: error
            });
          }
        );
      },
      function (error: any) {
        console.error(error);
        setShowFormLoading(false);
        globalFunctions.HandleToast({
          header: "Error",
          id: "Case-Query-Add-Error",
          description: "Could not add new case query database",
          type: "danger",
          error: error
        });
      }
    );
  }

  const handleStatusChange = (e: any) => {

    switch (e) {
      case 'All':
        setItems(unfilteredItems);
        break;
      case 'Open':
        var filteredData = [
          ...unfilteredItems.filter((x: any) => {
            return x["isClosed"] === 0;
          })];
        setItems(filteredData);
        break;
      case 'Closed':
        var filteredData = [
          ...unfilteredItems.filter((x: any) => {
            return x["isClosed"] === 1;
          })];
        setItems(filteredData);
        break;

    }

    setStatusFilter(e);
  }

  const handleCloseView = () => {
    setNewQueryResponse({ message: '' });
    setShowNewReponseForm(false);
    setFormTitle('');
    setNewQueryDisabled(false);
  }

  const handleEdit = (_selected: any) => {

    setShowFormLoading(true);
    setFormTitle('Edit');
    setShowAddForm(true);
    setQuerySubject(_selected.querySubject);
    setQueryText(_selected.queryText);
    setSelectedCaseQuery(_selected);
    //setSelectedCaseQueryResponses(_selected.responses);
    setIsClosed(_selected.isClosed === 0 ? false : true);
    setCurrentStatus(_selected.isClosed);
    setFormTitle(_selected.isClosed === 0 ? 'Edit' : 'View');
    setShowNewReponseForm(false);

    globalDataRepo.GetCaseQueryResponseList(_selected.id, false).then(
      function (response: any) {
        setSelectedCaseQueryResponses(response);
        setShowFormLoading(false);
        setShowAddForm(true);
      },
      function (error: any) {
        console.error(error);
        setShowFormLoading(false);
        globalFunctions.HandleToast({
          header: "Error",
          id: "Case-Query-Response-List-Error",
          description: "Could not read query response list from database",
          type: "danger",
          error: error
        });
      }
    );
  }


  return (
    <div>
      <SideSheet
        isShown={true}
        containerProps={{
          display: 'flex',
          flex: '1',
          flexDirection: 'column',
          marginTop: '90px !important',
          width: '100%',
          height: '100%',
          paddingBottom: '20px',
        }}
        width={'100%'}>

        <IonContent fullscreen>
          <Row style={{ marginTop: '20px', marginLeft: '20px', marginRight: '20px', boxShadow: 'box-shadow: 0 0 1px rgb(67 90 111 / 30%), 0 2px 4px -2px rgb(67 90 111 / 47%)', padding: '20px', paddingTop: '0px', border: '1px solid lightgray', borderRadius: '10px', paddingLeft: '30px', paddingRight: '30px' }} >
            <Pane flex="1" overflowY="auto" padding={20}  >

              <Row >
                <Col sm={12} md={6} lg={10}>
                  <Heading style={{ paddingTop: '30px' }}> <b>My Queries</b> </Heading>
                </Col>

                <Col lg={2}  >
                  <Pane  >
                    <SelectField
                      label="Status" value={statusFilter} onChange={(e) => handleStatusChange(e.target.value)}
                    >
                      <option value="All"> All </option>
                      <option value="Open"> Open</option>
                      <option value="Closed"> Closed</option>

                    </SelectField>
                  </Pane>
                </Col>
              </Row>
              {items !== undefined && items.length > 0 ?
                <Row style={{ marginTop: '20px', marginLeft: '20px', marginRight: '20px', marginBottom: '20px', boxShadow: 'box-shadow: 0 0 1px rgb(67 90 111 / 30%), 0 2px 4px -2px rgb(67 90 111 / 47%)', border: '1px solid lightgray', paddingLeft: '0px', paddingRight: '0px' }}>

                  <Table style={{ width: '100%' }}>
                    <Table.Body>
                      {items.map((query: any, index: number) => (
                        <Table.Row key={index} style={{ height: 'auto' }}>
                          {query.isClosed ? <Table.Cell width={48} flex="none" style={{ background: '#52BD95', fontSize: '10px', borderCollapse: 'collapse', border: '5px', padding: '9px', color: 'white' }} > Closed </Table.Cell> : null}
                          <Table.TextCell>
                            <div style={{ padding: '10px' }}>
                              <Row>
                                <Col md={12} lg={11}>
                                  <p style={{ fontSize: "15px", fontWeight: 'bold' }}>{moment(query.queryDate).format("DD/MM/YYYY")} - Query From: {query.queryUser.name}</p>
                                  <p>Subject: {query.querySubject}</p>
                                  <p>Message: {query.queryText}</p>
                                </Col>
                              </Row>
                            </div>
                          </Table.TextCell>
                          <Table.Cell width={48} flex="none" style={{ background: 'white', borderLeft: '1px solid lightgray' }} onClick={() => handleEdit(query)}>
                            <IconButton icon={EditIcon} height={24} appearance="minimal" />
                          </Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.Body>
                  </Table>
                </Row>
                :
                <Row style={{ marginTop: '20px', marginLeft: '20px', marginRight: '20px', marginBottom: '20px', boxShadow: 'box-shadow: 0 0 1px rgb(67 90 111 / 30%), 0 2px 4px -2px rgb(67 90 111 / 47%)', padding: '20px', border: '1px solid lightgray', borderRadius: '10px', paddingLeft: '0px', paddingRight: '0px' }}>
                  <Heading style={{ paddingLeft: '20px' }}>No Cases Assigned to you</Heading>
                </Row>}

              {showAddForm ?
                <SideSheet
                  isShown={showAddForm}
                  onCloseComplete={() => handleCancel()}
                  containerProps={{
                    display: 'flex',
                    flex: '1',
                    flexDirection: 'column'
                  }}
                >
                  <Pane zIndex={1} tabIndex={1} flexShrink={0} elevation={0} backgroundColor="white">
                    <Pane padding={16} paddingTop={32}>
                      <Pane display="flex" marginBottom={10}>
                        <Icon icon={ChatIcon} size={25} marginRight={10} color='#234361' />
                        <Heading size={600}>{formTitle} Case Query</Heading>
                      </Pane>
                      <Paragraph size={400}>
                        All mandatory fields must be complete before you can add a new Case Query.
                      </Paragraph>
                    </Pane>
                  </Pane>
                  <Pane flex="1" overflowY="scroll" background="tint1" padding={16}>
                    <TextInputField
                      label="Query Subject"
                      required
                      value={querySubject}
                      onChange={(e: any) => setQuerySubject(e.target.value)}
                      isInvalid={querySubjectInvalid}
                      validationMessage={querySubjectInvalid ? "This field is required" : null}
                      disabled={true}
                    />
                    <Heading size={300} marginTop="default" style={{ marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '#425A70', fontWeight: '500' }}>
                      Query from user {globalState.user.forename + " " + globalState.user.surname}:</Heading>
                    <TextareaField id="textarea"
                      label="Query Text"
                      placeholder="Case query to be added here..."
                      height={150}
                      value={queryText}
                      onChange={(e: any) => setQueryText(e.target.value)}
                      isInvalid={queryTextInvalid}
                      validationMessage={queryTextInvalid ? "This field is required" : null}
                      disabled={true}
                      required
                    />
                    <Pane>
                      {formTitle !== "Add" ?
                        <Pane style={{ display: 'inline-flex', width: '100%' }}>
                          <Heading size={300} marginTop="default" style={{ marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '#425A70', fontWeight: '500', width: '83%' }}>Responses</Heading>
                          {selectedCaseQuery.isClosed === 0 ?
                            <Heading onClick={() => { setShowNewReponseForm(true); setNewQueryDisabled(false) }} size={300} marginTop="default" style={{ marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '#425A70', fontWeight: '500', textDecoration: 'underline', cursor: 'pointer' }}>Add Response</Heading>
                            : null}
                        </Pane> : null}
                      {showNewReponseForm ?
                        <Pane>
                          <Textarea
                            id="textarea"
                            placeholder="Reponse information to be added here..."
                            height={150}
                            //value={newQueryResponse.message}
                            onChange={(e: any) => {
                              var _response = newQueryResponse;
                              _response.message = e.target.value;
                              setNewQueryResponse(_response);
                            }}
                            marginBottom={24}
                          //disabled={newQueryDisabled ? true : false || selectedCase.caseStatus.description == "Closed" ? true : false}
                          />
                          {!newQueryDisabled ?
                            <Pane display="flex" float="right" paddingBottom={40}>
                              <Button marginRight={16} appearance="primary" intent="danger" iconBefore={TrashIcon} width={85} onClick={() => { setShowNewReponseForm(false); setNewQueryResponse({ message: '' }); }}>Cancel</Button>
                              {selectedCase.caseStatus.description !== "Closed" ? <Button appearance="primary" intent="success" iconBefore={AddIcon} width={85} paddingLeft={22} onClick={() => handleAddResponse()}>Save</Button> : null}
                            </Pane> :
                            <Pane display="flex" float="right" paddingBottom={40} marginTop={20}>
                              <Button appearance="primary" intent="danger" iconBefore={TrashIcon} width={85} onClick={() => handleCloseView()}>Close</Button>
                            </Pane>}
                        </Pane> : null}
                      {!showNewReponseForm && selectedCaseQuery !== null &&
                        selectedCaseQueryResponses !== undefined && selectedCaseQueryResponses.length > 0 ?
                        <Row style={{ marginTop: '20px', marginLeft: '0px', marginRight: '0px', width: '100%', boxShadow: 'box-shadow: 0 0 1px rgb(67 90 111 / 30%), 0 2px 4px -2px rgb(67 90 111 / 47%)', border: '1px solid lightgray', borderRadius: '10px', paddingLeft: '0px', paddingRight: '0px' }}>
                          <Table style={{ width: '100%' }}>
                            <Table.Body>
                              {selectedCaseQueryResponses.map((_response: any, index: any) => (
                                <Table.Row key={index} style={{ height: '100%' }}>
                                  <Table.TextCell style={{ padding: '0px' }}>
                                    <div style={{ marginTop: '10px', paddingLeft: '10px' }}>
                                      <p style={{ marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '12px', color: '#425A70', fontWeight: '400' }}>Added By: {_response.responseUser !== undefined ? _response.responseUser.name : ""}</p>
                                      <p style={{ marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '12px', color: '#425A70', fontWeight: '400' }}>Added Date: {moment(_response.responseDate).format("DD/MM/YYYY")}</p>
                                      <p style={{ marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '12px', color: '#425A70', fontWeight: '400' }}>Message: {_response.message}</p>
                                    </div>
                                  </Table.TextCell>
                                  {/* <Table.Cell width={48} flex="none">
                            <IconButton onClick={() => viewReply(_response)} icon={EyeOpenIcon} height={24} appearance="minimal" />
                          </Table.Cell> */}
                                </Table.Row>
                              ))}
                            </Table.Body>
                            {showNewQueryFormLoading ?
                              <Pane display="flex" alignItems="center" justifyContent="center" height="100%" background="rgba(0,0,0,0.05)" style={{ position: 'absolute', width: '100%', top: '0' }}>
                                <Spinner></Spinner>
                              </Pane> : null}
                          </Table>
                        </Row> : null}
                    </Pane>


                    {/* {formTitle !== 'Add' && !showNewReponseForm && currentStatus === isClosed ?
              <Pane display="flex" float="right" paddingBottom={40} marginTop={20}>
                <Button appearance="primary" intent="danger" iconBefore={TrashIcon} width={85} onClick={handleCancel}>Close</Button>
              </Pane> : null} */}

                    {formTitle !== 'Add' && !showNewReponseForm && currentStatus !== isClosed && selectedCaseQuery.isClosed === 0 ?
                      <Pane display="flex" float="right" paddingBottom={40} marginTop={20}>
                        <Button appearance="primary" intent="success" iconBefore={AddIcon} width={85} paddingLeft={22} onClick={() => updateStatus()}>Save</Button>
                      </Pane> : null}

                    {formTitle !== "Add" && !showNewReponseForm && selectedCase.caseStatus.description !== "Closed" && selectedCaseQuery.isClosed === 0 ?
                      <Row style={{ marginTop: '25px' }}>
                        <Col xs={12} sm={6} md={6} lg={6} style={{ display: 'inline-flex', paddingLeft: '0px', paddingRight: '0px' }}>
                          <Heading size={300} marginTop="default" style={{ marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '#425A70', fontWeight: '500' }}>Close Query?</Heading>
                          <Checkbox marginLeft={15} marginTop={2} label="Yes"
                            checked={isClosed}
                            onChange={(e) => { setIsClosed(e.target.checked ? true : false) }}
                            disabled={selectedCase.caseStatus.description == "Closed" ? true : false}
                          />

                        </Col>
                      </Row>
                      : null}
                  </Pane>

                  {showFormLoading ?
                    <Pane display="flex" alignItems="center" justifyContent="center" height="100%" background="rgba(0,0,0,0.05)" style={{ position: 'absolute', width: '100%', top: '0' }}>
                      <Spinner></Spinner>
                    </Pane> : null}
                </SideSheet>
                : null}


            </Pane>
          </Row>
        </IonContent>
        <IonFab onClick={() => closeComplete()} vertical="bottom" horizontal="start" edge slot="fixed" style={{ bottom: "10px", right: "15px", width: '50px' }}>
          <IonFabButton style={{ width: "50px", height: "50px" }}>
            <Icon icon={UndoIcon} size={20} color='white' />
          </IonFabButton>
        </IonFab>
      </SideSheet>
    </div>
  );
};